import config from 'config'

// For local development start credible-bowtie-ui-proxy project to communicate with bowtie api
// https://github.com/crediblelabs/credible-bowtie-ui-proxy
// Set up:
// clone the proxy
// npm i from credible-bowtie-ui-proxy/tlano-proxy
// make local from credible-bowtie-ui-proxy/
// it will run proxy on 3001 port
export const API_URL = `${config.bowtieProxyRoot}${config.bowtieProxyUrl}`

export const GET_PRICES_FOR_ALL_STATES_URL = '/calculator/get-prices-for-all-states'
export const GET_PRICES_FOR_STATE_URL = '/calculator/get-prices-for-state'
export const GET_COUNTY_DATA_BY_ZIP_CODE_URL = '/calculator/get-county-data-by-zip-code'
export const GET_PRICES_FOR_COUNTY_URL = '/calculator/get-prices-for-county'

export const DEFAULT_COVERAGE = '250k'
export const DROPDOWN_OPTIONS = [
  { value: '100k', label: '$100,000' },
  { value: '250k', label: '$250,000' },
  { value: '500k', label: '$500,000' },
  { value: '750k', label: '$750,000' },
  { value: '1m', label: '$1,000,000' },
]

export const FORM_NAME = 'map-widget-form'

export const INSURANCE_FORM_URL = `${config.credibleRoot}/insurance/get-started`
export const INSURANCE_FORM_EMBEDDED_URL = `${config.credibleRoot}/insurance/get-started-embedded`

export const MAP_WIDGET_TYPE = 'map-widget'
export const CALCULATOR_WITH_INSURANCE_FORM_TYPE = 'calculator-with-insurance-form'
